// Lucide icons (ISC licence), drawn inline so they inherit colour and size from the text.
import { h } from 'preact';
import {
  House, Layers, User, ShieldCheck, Play, FileText, Check, ChevronRight, ChevronLeft, Search, RefreshCw,
  ExternalLink, LogOut, Download, Clock, CalendarDays, Users, FolderOpen, TriangleAlert, X, Plus, Settings,
  BookOpen, CircleCheck, ArrowUpDown, Share, MonitorPlay, UserPlus, Pencil, Link as LinkIcon, Info, MessageCircle,
  Bell, BellOff, Megaphone, Video, Pin, Trash2, Repeat, CalendarPlus, History,
  Camera, SendHorizontal, ReceiptIndianRupee, IndianRupee, Printer, MessageCircleQuestion,
  ClipboardCheck, Timer, Flag, Upload, FileSpreadsheet, ArrowUp, ArrowDown, Eye, CircleX, Library, Copy, Grid3x3, ChartColumn,
  HeartHandshake, UserCheck, Lock, ScrollText, Cake, Mail, UserX,
} from 'lucide';

export const icons = {
  home: House, layers: Layers, user: User, shield: ShieldCheck, play: Play, file: FileText, check: Check,
  next: ChevronRight, prev: ChevronLeft, search: Search, refresh: RefreshCw, external: ExternalLink, logout: LogOut,
  download: Download, clock: Clock, calendar: CalendarDays, users: Users, folder: FolderOpen, alert: TriangleAlert,
  close: X, plus: Plus, settings: Settings, book: BookOpen, done: CircleCheck, sort: ArrowUpDown, share: Share,
  video: MonitorPlay, adduser: UserPlus, edit: Pencil, link: LinkIcon, info: Info, chat: MessageCircle,
  bell: Bell, belloff: BellOff, megaphone: Megaphone, teams: Video, pin: Pin, trash: Trash2, repeat: Repeat,
  addcal: CalendarPlus, history: History,
  camera: Camera, send: SendHorizontal, receipt: ReceiptIndianRupee, rupee: IndianRupee, print: Printer, doubt: MessageCircleQuestion,
  tests: ClipboardCheck, timer: Timer, flag: Flag, upload: Upload, sheet: FileSpreadsheet, up: ArrowUp, down: ArrowDown,
  eye: Eye, wrong: CircleX, bank: Library, copy: Copy, grid: Grid3x3, chart: ChartColumn,
  family: HeartHandshake, usercheck: UserCheck, lock: Lock, notice: ScrollText, cake: Cake, mail: Mail, userx: UserX,
};

export function Icon({ name, size, label, class: cls }) {
  const node = icons[name];
  if (!node) return null;
  return h('svg', {
    class: `ic${cls ? ' ' + cls : ''}`,
    width: size || undefined,
    height: size || undefined,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': 2,
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'aria-hidden': label ? undefined : 'true',
    role: label ? 'img' : undefined,
    'aria-label': label || undefined,
    focusable: 'false',
  }, node.map(([tag, attrs], i) => h(tag, { ...attrs, key: i })));
}
